import React from 'react';

import Breadcrumb from '../breadcrumb';
import CallToAction from '../callToAction';

export function QuirionContent({ article, widgets, WidgetRenderer, FormRenderer }) {
  return (
    <div>
      <div className="section hero hero-split topstart short wf-section">
        <div className="spacer small"></div>
        <div className="container hero">
          <div className="row split-row">
            <div
              id="w-node-_78308165-7612-8561-eec0-bc6fa3a39e61-a3a39e5d"
              className="content-width-medium hero-content center"
            >
              {!!article.breadcrumb && !!article.breadcrumb.length && (
                <div className="title-tag">
                  <Breadcrumb breadcrumb={article.breadcrumb} />
                </div>
              )}
              {!!article.title && <h1>{article.title}</h1>}
              {WidgetRenderer.renderWidgets(widgets, 'before-main-content')}
              <div
                className="hero-subline"
                dangerouslySetInnerHTML={{ __html: article.mainContent }}
              />
            </div>
          </div>
        </div>
        <div className="spacer small"></div>
      </div>
      <div className="section grey wf-section">
        <div className="container small">
          <div className="hidden-mobile">
            <CallToAction
              callToActionText={article.callToActionText}
              callToActionLink={article.callToActionLink}
            />
          </div>
          {WidgetRenderer.renderWidgets(widgets, 'main-content-before-form')}
          {FormRenderer.displayFor(article, 'main_content')}
          {FormRenderer.formInModal(article, 'modal_main_content')}
          {WidgetRenderer.renderWidgets(widgets, 'main-content')}
          <div className="hidden-desktop">
            <CallToAction
              callToActionText={article.callToActionText}
              callToActionLink={article.callToActionLink}
            />
          </div>
          {WidgetRenderer.renderWidgets(widgets, 'further-content-before-form')}
          {FormRenderer.displayFor(article, 'further_content')}
          {FormRenderer.formInModal(article, 'modal')}
          {WidgetRenderer.renderWidgets(widgets, 'further-content')}
        </div>
      </div>
    </div>
  );
}

QuirionContent.propTypes = {
  article: React.PropTypes.object,
  widgets: React.PropTypes.array,
  WidgetRenderer: React.PropTypes.object,
  FormRenderer: React.PropTypes.object
};



// WEBPACK FOOTER //
// ./components/articles/QuirionContent.js